import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchContent, fetchReleases, fetchVideos, fetchProducts } from "../lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [releases, setReleases] = useState([]);
  const [videos, setVideos] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const [c, r, v, p] = await Promise.all([
        fetchContent(),
        fetchReleases(),
        fetchVideos(),
        fetchProducts(),
      ]);
      setContent(c);
      setReleases(r);
      setVideos(v);
      setProducts(p);
    } catch (e) {
      console.error("Content load failed", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ content, releases, videos, products, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
